import React from "react";

// Extracted verbatim from LandingPage.jsx (lines 238-291) — shared by LandingPage.jsx and
// CommonPaymentPage.jsx so neither keeps its own copy.
const SpinnerOverlay = ({ message = "Processing..." }) => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(255,255,255,0.75)",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      transition: "opacity 0.2s",
    }}
  >
    <div
      style={{
        border: "6px solid #ffe0b2",
        borderTop: "6px solid #f57c00",
        borderRadius: "50%",
        width: 60,
        height: 60,
        animation: "spin 1s linear infinite",
        marginBottom: 18,
      }}
    />
    <div
      style={{
        fontSize: "16px",
        fontWeight: 500,
        color: "#3E2723",
        textAlign: "center",
      }}
    >
      {message}
    </div>
    <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }`}</style>
    <style>{`
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }
    `}</style>
  </div>
);

export default SpinnerOverlay;
